module.exports = __webpack_public_path__ + "static/kulturwerke-quer-de67f019a5f9db9dd86a07039cb3bfc5.png";